import React from "react";
import "../App.css";
import useCounter from "../hooks/useCounter";
import "./Counter.css";

const Counter = () => {
	const startup = useCounter(20, 1000);
	const investment = useCounter(10, 1500);
	const workSession = useCounter(50, 2000);
	const cno = useCounter(179, 3000);

	// document.addEventListener("DOMContentLoaded", () => {
	// 	function counter(id, start, end, duration) {
	// 		let obj = document.getElementById(id),
	// 			current = start,
	// 			range = end - start,
	// 			increment = end > start ? 1 : -1,
	// 			step = Math.abs(Math.floor(duration / range)),
	// 			timer = setInterval(() => {
	// 				current += increment;
	// 				obj.textContent = current;
	// 				if (current == end) {
	// 					clearInterval(timer);
	// 				}
	// 			}, step);
	// 	}
	// 	counter("count1", 0, 20, 1000);
	// 	counter("count2", 0, 10, 500);
	// 	counter("count3", 0, 50, 2000);
	// 	counter("count4", 0, 179, 3000);
	// });

	return (
		<div id="counter" className="container-fluid">
			<section className="counter_wrapper">
				<div className="container">
					<div className="row text-center">
						<div className="col-md-3 mb-lg-0 mb-md-0 mb-4 box">
							<h2>
								<span>{startup.count}</span>+<p>Startup</p>
							</h2>
						</div>
						<div className="col-md-3 mb-lg-0 mb-md-0 mb-4 box">
							<h2>
								<span>{investment.count}</span>+
								<p> Investment</p>
							</h2>
						</div>
						<div className="col-md-3 mb-lg-0 mb-md-0 mb-4 box">
							<h2>
								<span>{workSession.count}</span>+
								<p>Workshop Sessions</p>
							</h2>
						</div>
						<div className="col-md-3 mb-lg-0 mb-md-0 mb-4 box">
							<h2>
								<span>{cno.count}</span>+
								<p>Career Networking Opportunities </p>
							</h2>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};
export default Counter;
